/**
 * Gallery video autoplay controller.
 *
 * Videos are rendered with `preload="metadata"` and no `autoplay` attribute so the
 * browser only fetches metadata up front. Playback is started/stopped manually via
 * IntersectionObserver instead of relying on the native `autoplay` + `loading="lazy"`
 * combination, which can leave videos stuck on a frozen frame in Chrome on Android.
 */
(function () {
	if (!('IntersectionObserver' in window)) return;

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				var video = entry.target;

				if (entry.isIntersecting) {
					if (video.readyState === 0) {
						video.load();
					}
					var playPromise = video.play();
					if (playPromise && typeof playPromise.catch === 'function') {
						playPromise.catch(function () {
							/* Autoplay can be blocked by the browser; fail silently. */
						});
					}
				} else {
					video.pause();
				}
			});
		},
		{
			// Start loading/playing slightly before the video enters the viewport
			// so it's ready by the time it's visible.
			rootMargin: '200px 0px',
			threshold: 0.15
		}
	);

	function observeGalleryVideos(root) {
		var scope = root || document;
		var videos = scope.querySelectorAll('.gallery__video');
		videos.forEach(function (video) {
			observer.observe(video);
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		observeGalleryVideos(document);
	});

	// Re-observe videos in sections added/edited in the theme editor.
	document.addEventListener('shopify:section:load', function (event) {
		observeGalleryVideos(event.target);
	});
})();